import propTypes from 'prop-types';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';

const InputDatetime = ({value, dateFormat, timeFormat, onChange, inputProps, className}) => {
    return (
        <Datetime
            className={className}
            value={value}
            inputProps={inputProps}
            dateFormat={dateFormat}
            timeFormat={timeFormat}
            onChange={onChange}
        />
    )
}

InputDatetime.propTypes = {
    value: propTypes.object.isRequired,
    dateFormat: propTypes.string,
    timeFormat: propTypes.string,
    onChange: propTypes.func.isRequired,
    inputProps: propTypes.object
}

InputDatetime.defaultProps = {
    dateFormat: 'YYYY-MM-DD',
    inputProps: {
        placeholder: 'Pilih tanggal...'
    },
    timeFormat: 'HH:mm'
}

export default InputDatetime;
